<ds-modal #tpl size="sm"
          [ds-modal-trigger-for]="tpl"
          [(isModalOpen)]="visible"
          [isDismissable]="false">
  <ds-box-header>{{ 'case.addVin' | translate }}</ds-box-header>
  <ds-box-content>
    <p>{{ 'case.addVinDescription' | translate }}</p>

    <ds-form-field class="my-4x">
      <input
        ds-input
        ds-form-validation
        type="text"
        minlength="17"
        maxlength="17"
        [(ngModel)]="vin17Input"
        (keyup.enter)="confirm()"
        placeholder="VIN17"
        required
      />
      <ds-error>{{ 'case.enterValidVin17' | translate }}</ds-error>
    </ds-form-field>
  </ds-box-content>
  <ds-box-footer>
    <button ds-button variant="outline" class="m-3x" (click)="hide()">{{ 'common.cancel' | translate }}</button>
    <button ds-button
            (click)="confirm()"
            [disabled]="vin17Input?.length !== 17"
    >{{ 'common.ok' | translate }}
    </button>
  </ds-box-footer>
</ds-modal>
